// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__2MCH6","col":"CardReaderDesc_col__3xkXa","label":"CardReaderDesc_label__3sKeG"};